var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "internal" },
    [
      _c("div", { staticClass: "gradient-header" }),
      _c("Sidebar", {
        attrs: { "open-menu": _vm.openMenu },
        on: {
          hoverChange: _vm.handleHovered,
          openMenu: _vm.setOpenMenu,
          menuLock: _vm.handleMenuLocked,
        },
      }),
      _c(
        "div",
        {
          staticClass: "internal-content",
          class: _vm.isMenuLocked ? "expanded" : "reduced",
        },
        [
          _c("div", { staticClass: "gradient-header" }),
          _c("Header", {
            staticClass: "main-header",
            attrs: { "open-menu": _vm.openMenu },
            on: { openMenu: _vm.setOpenMenu },
          }),
          _c(
            "div",
            {
              staticClass: "general-content",
              attrs: { "data-cy": "general-content" },
            },
            [
              _c("Notifications"),
              _c(
                "transition",
                { attrs: { name: _vm.transitionName } },
                [_c("router-view")],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }